import { Trash2, Users } from 'lucide-react'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setMemberShipJson, setProductJson } from '../../redux/Actions/BillingAction'
import MySearchableSelect from '../../components/MyComponent/BillingSearchableSelect'
import { searchMembership, searchProduct, searchStaff, searchUser } from '../../constant/Constant'
import MyInput from '../../components/MyComponent/MyInput'
import { calculateBillSummary } from '../../utils/utils'
import { setDataAction } from '../../redux/Actions/SetDataAction'
import { SET_BILLING_MEMBERSHIP_DATA } from '../../redux/ActionName/ActionName'

export const MemberShipSection = () => {
    const BillingReducer = useSelector((state) => state.BillingReducer)
    const dispatch = useDispatch()


    const handelMemberShipChange = (type, value, index) => {

        const oldData = [...BillingReducer?.selectedMemberships]
        if (type === "selectMembership") {
            oldData[index] = { ...oldData[index], membership: value, price: value.specialOfferPrice, total: value.specialOfferPrice }
        }
        else if (type === "changeStaff") {
            oldData[index] = { ...oldData[index], staffData: value }
        }
        else if (type === "changePrice") {
            if (value !== '' && !/^(?:[0-9]+(?:\.[0-9]*)?)?$/.test(value)) return;
            oldData[index] = { ...oldData[index], price: value, total: value }
        }
        else if (type === "removeMembersip") {
            oldData[index] = { ...oldData[index] }
            oldData.splice(index, 1)
        }
        dispatch(setDataAction(oldData, SET_BILLING_MEMBERSHIP_DATA))
        const updatedBillingReducer = { ...BillingReducer, selectedMemberships: oldData };
        calculateBillSummary(updatedBillingReducer, dispatch);
    }
    console.log("Selected Memberships:", BillingReducer);
    return (
        <div> {(BillingReducer?.selectedMemberships || []).length > 0 && (
            <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center gap-2 mb-4">
                    <Users className="text-green-600" size={20} />
                    <h2 className="text-xl font-semibold text-gray-800">Select Membership</h2>
                </div>
                {BillingReducer?.selectedMemberships?.map((membership, index) => (
                    <div key={membership.id} className="grid grid-cols-4 gap-4 mb-4 items-end">
                        <div>
                            <MySearchableSelect giveFullElement={true} api={searchMembership} value={membership?.membership?.membershipName} optionLable="membershipName" onChange={(value) => handelMemberShipChange("selectMembership", value, index)} title="Search Service" placeholder={"Select Service"} />
                        </div>
                        <div>
                            <MySearchableSelect giveFullElement={true} api={searchUser} value={membership?.staffData?.name} optionLable="name" onChange={(value) => handelMemberShipChange("changeStaff", value, index)} title="Search Staff" placeholder={"Select Staff"} />
                        </div>
                        <div>
                            <MyInput onChange={(e) => handelMemberShipChange("changePrice", parseFloat(e.target.value) || 0, index)} title={'Price'} value={membership.price || ""} type="number" />
                        </div>
                        <div className="flex items-center gap-2">
                            <span className="text-lg font-semibold text-gray-800">₹{membership.total || 0}</span>
                            <button
                                onClick={() => handelMemberShipChange("removeMembersip", false, index)}
                                className="text-red-500 hover:text-red-700"
                            >
                                <Trash2 size={16} />
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        )}</div>
    )
}
